import { defineMessages } from 'react-intl';

export default defineMessages({
  adUnitSiteLoading: {
    id: 'tython.adunit.site.isLoading',
    defaultMessage: 'Loading...',
  },
});
